module.exports = __webpack_public_path__ + "static/img/start-logo.d0b15f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/welcomeCall/start-logo.svg
// module id = JHUp
// module chunks = 1